let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2o3ud")).then(() => parcelRequire('bGXHO'));